module.exports = __webpack_public_path__ + "static/media/WaystoSupport_Banner.7f574117.png";